import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({ template: '' })
export class EnterProjectComponent {
    constructor(router: Router, route: ActivatedRoute) {
        const { projectId } = route.snapshot.params;

        router.navigateByUrl(`/${projectId}`, { replaceUrl: true });
    }
}
